module.exports = __webpack_public_path__ + "img/web1icon5.b4f0d8d2.png";